export default "__VITE_ASSET__917d07ec__"